export const stats = [
  { value: '+70', label: 'Unités Prêtes à Enseigner' },
  { value: '+2.000', label: 'Enseignants Satisfaits' },
  { value: '4.200+', label: 'Heures Gagnées' },
  { value: '99%', label: 'Le Recommandent' },
]

export const differenceStats = [
  { value: '+70', label: 'Unités Prêtes (A1 à C2)' },
  { value: '6', label: 'Volumes Numériques Complets' },
  { value: '100%', label: 'Téléchargement Immédiat' },
]

export const beforeItems = [
  'Des heures passées à planifier chaque leçon de zéro',
  'Des exercices de grammaire répétitifs et ennuyeux',
  'Aucun lien clair avec le monde réel',
  "Difficulté à évaluer et à suivre les progrès",
  'Des élèves démotivés qui « détestent le français »',
]

export const afterItems = [
  '5 minutes de révision et vous êtes prêt pour la classe',
  'Des projets linguistiques visuels et stimulants',
  'Des applications réelles intégrées à chaque unité',
  'Quiz, examens et rubriques déjà prêts',
  'Des élèves qui parlent avec une confiance absolue',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: "Arriver en classe sans savoir exactement comment expliquer un temps verbal complexe",
  },
  {
    emoji: '⏱️',
    text: 'Passer tout le dimanche à préparer ce qui devrait prendre quelques minutes',
  },
  {
    emoji: '🤷',
    text: 'Chercher sans fin des fiches pédagogiques vraiment visuelles et de qualité',
  },
  {
    emoji: '📋',
    text: "Aucune évaluation ni rubrique claire alignée sur l'année scolaire",
  },
  {
    emoji: '😴',
    text: "Des élèves qui décrochent parce que le matériel n'est pas adapté à leur niveau",
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '6 Volumes par Niveaux (A1–C2)',
    text: 'Un programme complet du débutant absolu au français avancé',
  },
  {
    emoji: '🏛️',
    title: 'Le Master Plan',
    text: "Le système d'exploitation du professeur : calendriers, rubriques et tests de placement",
  },
  {
    emoji: '✏️',
    title: 'Scripts de Cours',
    text: 'Des instructions claires pour mener la leçon sans stress',
  },
  {
    emoji: '📐',
    title: 'Grammaire Visuelle',
    text: 'Graphismes HD pour simplifier les règles complexes',
  },
  {
    emoji: '📊',
    title: 'Évaluations Finales',
    text: 'Des outils complets pour valider chaque étape',
  },
  {
    emoji: '🔑',
    title: 'Corrigés Complets',
    text: 'Toutes les solutions incluses, corrections instantanées et sans stress',
  },
]

export const pageSamples = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/kLHwzqgK63amP1xiXuBHc9/Captura-de-pantalla-2026-09-09-a-la_s_-7.11.09_p._m..webp',
    level: 'A1 · Dialogue',
    title: 'Quel âge as-tu ?',
    caption:
      'Dialogue illustré, structure à compléter et note de grammaire sur AVOIR pour dire son âge.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2ygTE3sxDGhdfSQxDb86NZ/Captura-de-pantalla-2026-09-09-a-la_s_-7.11.55_p._m..webp',
    level: 'A2 · Vocabulaire',
    title: 'La liste de courses visuelle',
    caption:
      'Fiche visuelle prête à imprimer pour travailler les articles partitifs et le lexique des aliments.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/69p6RPqjNWj1qzPkYjdEr2/Captura-de-pantalla-2026-09-09-a-la_s_-7.12.54_p._m..webp',
    level: 'B1 · Exercice',
    title: 'Passé composé ou imparfait ?',
    caption:
      'Exercice à trous pour choisir le bon temps du passé, avec consigne claire et espaces de réponse.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cLpg72P6zj7uboU5N5U3g9/Captura-de-pantalla-2026-09-09-a-la_s_-7.15.49_p._m..webp',
    level: 'C1 · Évaluation',
    title: 'Quiz : expression formelle écrite',
    caption:
      'Consigne de rédaction et grille de notation sur 10 points, critère par critère.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/bmSTBV51NEyP8q86SiR7pZ/Captura_de_pantalla_2026-09-09_a_la(s)_7.17.22_p.webp',
    level: 'C2 · Activité',
    title: 'Les connecteurs logiques complexes',
    caption:
      'Classement des connecteurs par fonction logique, avec banque de mots pour les niveaux avancés.',
  },
]

export const bonuses = [
  {
    title: 'Planificateur Express™',
    was: '19€',
    text: 'Planifiez votre semaine en moins de 10 minutes grâce à nos modèles stratégiques.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/224fe89d-067b-43f9-9622-16856cb7a1d1.jpg',
  },
  {
    title: 'Cent Jeux Sans Matériel™',
    was: '27€',
    text: 'La ressource ultime pour dynamiser vos cours instantanément, sans aucune préparation.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/05ecbeef-1331-41df-bbcb-11bd64970c97.jpg',
  },
  {
    title: "Guide d'Immersion Totale™",
    was: '36€',
    text: 'Stratégies pour faire parler vos élèves uniquement en français dès le premier jour.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/ea472c8d-f310-4c22-91a3-82de9732fd45.jpg',
  },
  {
    title: 'Pack de 20 Évaluations Diagnostiques™',
    was: '47€',
    text: 'Identifiez les lacunes de vos élèves et mesurez leurs progrès avec précision.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/e1fee9a4-75f3-4736-9e06-ae308f811e04.jpg',
  },
  {
    title: 'La Bibliothèque de Vocabulaire Visuel™',
    was: '19€',
    text: '30 affiches haute définition prêtes à imprimer pour transformer votre salle de classe.',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/476dbbdb-9450-4e3e-ae9c-8445e128a1b7.jpg',
  },
]

export const offerRows = [
  { label: 'Pack FRANÇAIS PRÊT™ (6 Volumes Numériques)', value: '77€' },
  { label: '5 Bonus Stratégiques Exclusifs', value: '148€' },
]

export const testimonials = [
  {
    quote:
      "J'ai récupéré mes dimanches. La progression de A1 à C2 est parfaite.",
    name: 'Claire M.',
    location: 'Lyon 🇫🇷',
  },
  {
    quote:
      'Les cartes grammaticales visuelles font une énorme différence pour mes élèves.',
    name: 'Marc L.',
    location: 'Paris 🇫🇷',
  },
  {
    quote:
      'Enfin une ressource professionnelle, organisée et prête à imprimer.',
    name: 'Élodie V.',
    location: 'Bordeaux 🇫🇷',
  },
]

export const faqs = [
  {
    q: 'Comment recevoir le matériel ?',
    a: 'Immédiatement après le paiement, par e-mail : vous recevrez un lien pour télécharger tous les fichiers numériques.',
  },
  {
    q: 'Cela fonctionne-t-il si je débute dans l’enseignement ?',
    a: 'Absolument. Les scripts vous indiquent exactement quoi faire en classe, étape par étape.',
  },
  {
    q: 'Quels niveaux sont couverts ?',
    a: 'Tout le spectre du CECRL : A1, A2, B1, B2, C1 et C2, avec des contextes pour enfants, adolescents et adultes.',
  },
  {
    q: 'Y a-t-il des frais mensuels ?',
    a: "Non, c'est un paiement unique de 27 USD. Aucun abonnement, aucun frais caché.",
  },
]
